import Config from "../../config/Config";
import {
  createArrayEntityFromObject,
  createQueryUrl,
  getEntity,
} from "../../config/global";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlDev;

export const getTransactions = (month, year, filter) => {
  let url = `${baseUrlDev}python/transaction/report?month=${month}&year=${year}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getOlderTransactions = (month, year) => {
  let url = `${baseUrlDev}python/transaction/report/old?month=${month}&year=${year}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getdetailTransaction = (month, year, transactionName) => {
  let url = `${baseUrlDev}python/transaction/report/detail?month=${month}&year=${year}&sort=createDate%2CDesc&transactionName=${transactionName}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getdetailOlderTransaction = (month, year, transactionName) => {
  let url = `${baseUrlDev}python/transaction/report/old/detail?month=${month}&year=${year}&sort=createDate%2CDesc&transactionName=${transactionName}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
